import BetweenDateFormat from './between-date-to-query-string'
import Debouncer from './Debouncer'
import formatCents, { formatCentsToSendToBackEnd } from './format-cents'
import formatCep from './FormatCep'
import formatCpfCnpj, { getDocumentType } from './FormatCpfCnpj'
import {
  currency,
  formatMoney,
  onlyNumber,
  priceConverter
} from './FormatMoney'
import formatMonth from './FormatMonth'
import formatPercent from './FormatPercent'
import formatPhone from './FormatPhone'
import { normalizeString } from './normalize-string'
import objectToQueryString from './object-to-query-string'
import UFOptions from './UF'

function isEmpty(obj: any) {
  return Object.keys(obj).length === 0
}

export {
  BetweenDateFormat,
  currency,
  Debouncer,
  formatCents,
  formatCentsToSendToBackEnd,
  formatCep,
  formatCpfCnpj,
  formatMoney,
  formatMonth,
  formatPercent,
  formatPhone,
  getDocumentType,
  isEmpty,
  normalizeString,
  objectToQueryString,
  onlyNumber,
  priceConverter,
  UFOptions
}
